export const DEFAULT_TIMING = '100ms';
